/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycProcessStatisticsDto } from '../../models/kyc-process-statistics-dto';

export interface GetStatistics$Params {
  managementCompanyId: string;
  statuses?: Array<'PENDING' | 'DRAFT' | 'IN_PROGRESS' | 'FOR_APPROVAL' | 'CHANGES_REQUESTED' | 'COMPLETED' | 'REJECTED'>;
  riskLevels?: Array<'LOW' | 'MEDIUM_LOW' | 'MEDIUM_HIGH' | 'HIGH'>;
  clientTypes?: Array<'INDIVIDUAL' | 'COMPANY' | 'TARGET_COMPANY' | 'COUNTERPARTY'>;
  fundNames?: Array<string>;
  clientName?: string;
}

export function getStatistics(http: HttpClient, rootUrl: string, params: GetStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<KycProcessStatisticsDto>> {
  const rb = new RequestBuilder(rootUrl, getStatistics.PATH, 'get');
  if (params) {
    rb.query('managementCompanyId', params.managementCompanyId, {});
    rb.query('statuses', params.statuses, {});
    rb.query('riskLevels', params.riskLevels, {});
    rb.query('clientTypes', params.clientTypes, {});
    rb.query('fundNames', params.fundNames, {});
    rb.query('clientName', params.clientName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycProcessStatisticsDto>;
    })
  );
}

getStatistics.PATH = '/kyc/processes/statistics';
